<template>
  <div class="product-card__title" data-eq-part="product-card__title">
    <div>
      <LazyBackgroundMedia
          v-if="hasCategoryImage"
          class="product-card__title-icon"
          icon
          :media-url="product.category.image?.url"
          background-position-y="center"
          background-position-x="center"
          no-repeat
      />
    </div>
    <div>
      <div class="product-card__title-name">{{ product.name }}</div>
      <div class="product-card__title-slogan">{{ product.slogan || '## Slogan ##' }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Product from '@/classes/Product';
import { computed } from 'vue';

const props = defineProps<{
  product: Product
}>();

const hasCategoryImage = computed(() => !!props.product.category.image?.url);
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.product-card__title {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 20px;
  text-align: left;
  padding: 20px 20px 15px;
  align-items: center;

  @media(min-width: map-get($grid-breakpoints, 'lg')) {
    gap: 30px;
    padding: 30px 40px 20px;
  }

  &-icon {
    font-size: 55px;
    background-color: #fff;
    width: 1em;
    height: 1em;
    z-index: 3;

    .icon {
      background-size: contain;
    }

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
      font-size: 90px;
    }
  }

  &-name {
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.5;

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
      font-size: 1.875rem;
    }
  }

  &-slogan {
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
      font-size: 1.25rem;
    }

    &:empty {
      display: none;
    }
  }
}
</style>
